import { gql } from '@apollo/client';

export const GetAdditionalProducts = gql`
    query getAdditionalProducts {
        getAdditionalProducts {
            success
            error
            products {
                priceId
                priceAmount
                minutes
            }
        }
    }
`;
